<template>
  <div>
      <v-dialog  v-model="isVisible" @keydown.esc="close" :max-width="tamanho">
        <v-card elevation="10" >
          <v-card-title>
            <v-row class=" w-full justify-between items-center">
       
            <span style="font-size:20px;">{{ title }}</span>
            <v-icon size="50"  :color="pegarCorTipo()"
            >{{ pegarIconTipo() }}</v-icon>
        </v-row>
            </v-card-title>
          <v-card-text>
            <div style="font-size:14px;" v-html="message"></div>
    
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn @click="handleCancel">{{ cancelText }}</v-btn>
            <v-btn color="primary" @click="handleConfirm">{{
              confirmText
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-overlay>
  </div>
</template>
  
  <script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    message: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    onConfirm: {
      type: Function,
      required: true,
    },
    onCancel: {
      type: Function,
      default: () => {},
    },
    confirmText: {
      type: String,
      default: "Confirmar",
    },
    cancelText: {
      type: String,
      default: "Cancelar",
    },
    tamanho: {
      default: 500,
    },
  },
  data() {
    return {
      isVisible: false,
    };
  },
  methods: {
    open() {
      this.isVisible = true;
    },
    close() {
      this.isVisible = false;
      this.onCancel();
    },
    handleConfirm() {
      this.onConfirm();
      this.isVisible = false;
    },
    handleCancel() {
      this.close();
    },
    pegarIconTipo() {
      switch (this.type) {
        case "is-success":
          return "mdi-check-circle"; // Icon for success
        case "is-warning":
          return "mdi-alert-circle"; // Icon for warning
        case "is-error":
          return "mdi-alert"; // Icon for error
        case "is-info":
          return "mdi-information"; // Icon for info
        default:
          return "mdi-help-circle"; // Default icon
      }
    },
    pegarCorTipo() {
        switch (this.type) {
            case "is-success":
                return "#4CAF50"; // Color for success
            case "is-warning":
                return "#FFC107"; // Color for warning
            case "is-error":
                return "#F44336"; // Color for error
            case "is-info":
                return "#2196F3"; // Color for info
            default:
                return "#9E9E9E"; // Default color
        }
    }
  },
};
</script>
  
  <style scoped>
/* Estilos personalizados para o modal, se necessário */
</style>
  